// extracted by mini-css-extract-plugin
export default {"page-title-container":"PageTitle_page-title-container__KSMKL","page-title-icon":"PageTitle_page-title-icon__+UhOR"};